import { render, staticRenderFns } from "./LicenseFormBox.vue?vue&type=template&id=4262c622&scoped=true"
import script from "./LicenseFormBox.vue?vue&type=script&lang=js"
export * from "./LicenseFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./LicenseFormBox.vue?vue&type=style&index=2&id=4262c622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4262c622",
  null
  
)

export default component.exports